<mat-paginator [hidden]="hidden" [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" (page)="setPageSize($event)"
    class="sticky left-0"></mat-paginator>